/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import bulkProvisioningTemplate from './bulk-provisioning/bulk-provisioning.dialog.tpl.html';
import assigningTemplate from './assigning/assigning.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceTableConfig($q, $rootScope, $translate, $mdDialog, $state, $log, $filter, $timeout, types, utils, tkDialogs, userService,
                                           deviceService, networkSettingsService, apiLimitsService, applicationService, multicastGroupService) {

    var deviceStateSubscriptions = {};

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;


        if (params.applicationId) {
            applicationService.getApplication(params.applicationId).then(
                (application) => {
                    var tableConfiguration = createDeviceConfig(scope, access, params, application.name);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else if (params.multicastGroupId) {
            multicastGroupService.getMulticastGroup(params.multicastGroupId).then(
                (multicastGroup) => {
                    var tableConfiguration = createDeviceConfig(scope, access, params, multicastGroup.name);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createDeviceConfig(scope, access, params);
            loadDeviceModelOptions(scope, currentUser, tableConfiguration).finally(function () {
                deferred.resolve(tableConfiguration);
            });
        }
        return deferred.promise;
    }

    function createDeviceConfig(scope, access, params, entityTitle) {

        var applicationId = params.applicationId;
        var multicastGroupId = params.multicastGroupId;
        var currentUser = userService.getCurrentUser();

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.device,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                {
                    key: 'createdTime',
                    sortOrder: types.entityTable.sortOrder.desc.value,
                    sortKey: 'CREATED_TIME',
                    title: 'entity.createdTime'
                },
                {
                    key: 'name',
                    sortKey: 'NAME',
                    title: 'device.name'
                },
                {
                    key: 'deviceModelName',
                    sortKey: 'DEVICE_MODEL_NAME',
                    title: 'device-model.device-model'
                },
                {
                    key: 'deviceClass',
                    sortKey: 'DEVICE_CLASS',
                    title: 'device-model.device-class',
                    cellContentFunction: (value) => $translate.instant(types.deviceClass[value].name)
                },
                {
                    key: 'deviceEUI',
                    sortKey: 'DEVICE_EUI',
                    title: 'device.device-eui'
                },
                {
                    key: 'appEUI',
                    sortKey: 'APPLICATION_EUI',
                    title: 'device.app-eui'
                },
                {
                    key: 'applicationName',
                    sortKey: 'APPLICATION_NAME',
                    title: 'device.app-name'
                },
                {
                    key: 'active',
                    sortKey: 'STATUS',
                    title: 'device.status',
                    cellContentFunction: (value) => {
                        if (value) {
                            return $translate.instant('device.online');
                        } else {
                            return $translate.instant('device.offline');
                        }
                    },
                    cellStyleFunction: (value) => {
                        if (value) {
                            return {color: '#1a901a'};
                        } else {
                            return {color: '#ff0000'};
                        }
                    }
                }
            ],

            serverPagedData: true,
            addEntityController: 'AddDeviceController',
            bulkProvisioningTemplate: bulkProvisioningTemplate,
            bulkProvisioningController: 'DeviceBulkProvisioningController',
            assignEntityTemplate: assigningTemplate,
            assignEntityController: 'AssignDeviceController',

            loadEntities: ($scope) => {
                return multicastGroupId
                    ? loadDevices($scope, multicastGroupId, deviceService.getMulticastGroupDevices)
                    : applicationId
                        ? loadDevices($scope, applicationId, deviceService.getApplicationDevices)
                        : scope === types.scope.customer
                            ? loadDevices($scope, currentUser.customerId, deviceService.getCustomerDevices)
                            : loadDevices($scope, currentUser.subCustomerId, deviceService.getSubCustomerDevices)
            },
            loadEntity: (entityId) => {return loadDevice(entityId)},
            saveEntity: (entity) => {return saveDevice(entity)},
            deleteEntity: (entityId) => {
                $rootScope.shouldOverlay = true;
                return deviceService.deleteDevice(entityId)
                    .then(function() {
                        $rootScope.shouldOverlay = false;
                    })
                    .catch(function() {
                        $rootScope.shouldOverlay = false;
                    })
            },
            subscribeEntities: ($scope, entities) => {return subscribeForDevicesState($scope, entities)},
            unsubscribeAllEntities: () => {unsubscribeFromDeviceStates()},

            onDestroy: () => {
                unsubscribeFromDeviceStates();
            },

            addEnabled: () => {
                return access === types.access.admin && applicationId;
            },

            assignEnabled: () => {
                return access === types.access.admin && multicastGroupId;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin && !multicastGroupId;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin && !multicastGroupId;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('device.delete-device-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('device.delete-device-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('device.delete-devices-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('device.delete-devices-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'application.application-details',
                icon: 'apps',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    openApplicationDetails($event, entity.applicationId);
                }
            },
            {
                 name: 'device.move-to-application',
                 icon: 'swap_vertical_circle',
                 isEnabled: () => {
                     return access === types.access.admin && !multicastGroupId;
                 },
                 onAction: ($event, entity) => {
                     moveDeviceToApplication($event, entity, tableConfiguration);
                 }
            },
            {
                 name: 'device.add-to-multicast-group',
                 icon: 'device_hub',
                 isEnabled: () => {
                     return access === types.access.admin && !multicastGroupId;
                 },
                 onAction: ($event, entity) => {
                     addDeviceToMulticastGroup($event, entity, tableConfiguration);
                 }
            },
            {
                 name: 'device.remove-from-multicast-group',
                 icon: 'indeterminate_check_box',
                 isEnabled: () => {
                     return access === types.access.admin && multicastGroupId;
                 },
                 onAction: ($event, entity) => {
                     removeDeviceFromMulticastGroup($event, multicastGroupId, entity, tableConfiguration);
                 }
            }
        ];

        tableConfiguration.groupActionDescriptors = [
            {
                 name: 'device.move-to-application',
                 icon: 'swap_vertical_circle',
                 isEnabled: () => {
                     return access === types.access.admin;
                 },
                 onAction: ($event, entities) => {
                     moveDevicesToApplication($event, entities, tableConfiguration);
                 }
            },
            {
                name: 'device.remove-from-multicast-group',
                icon: 'indeterminate_check_box',
                isEnabled: () => {
                    return access === types.access.admin && multicastGroupId;
                },
                onAction: ($event, entities) => {
                    removeDevicesFromMulticastGroup($event, multicastGroupId, entities, tableConfiguration);
                }
           },
            {
                name: 'device.add-to-multicast-group',
                icon: 'device_hub',
                isEnabled: () => {
                    return access === types.access.admin && !multicastGroupId;
                },
                onAction: ($event, entities) => {
                    addDevicesToMulticastGroup($event, entities, tableConfiguration);
                }
           }
        ];

        if (!applicationId && !multicastGroupId
            && (scope === types.scope.customer || scope === types.scope.subCustomer)) {
            tableConfiguration.refreshEnabled = true;
            tableConfiguration.columnFilters = [
                {
                    key: 'deviceModel',
                    title: $translate.instant('device-model.device-model'),
                    options: [],
                    selected: []
                },
                {
                    key: 'active',
                    title: $translate.instant('device.status'),
                    options: [
                        {value: true, name: $translate.instant('device.online')},
                        {value: false, name: $translate.instant('device.offline')}
                    ],
                    selected: []
                }
            ];
        }

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function loadDeviceModelOptions(scope, currentUser, tableConfiguration) {
        var filters = tableConfiguration.columnFilters || [];
        var deviceModelFilter = filters.filter((f) => f.key === 'deviceModel')[0];
        if (!deviceModelFilter) {
            return $q.when();
        }
        var loader = scope === types.scope.customer
            ? deviceService.getCustomerDeviceFilterValues(currentUser.customerId)
            : deviceService.getSubCustomerDeviceFilterValues(currentUser.subCustomerId);
        return loader.then(
            (filterValues) => {
                var models = (filterValues && filterValues.deviceModel) || [];
                deviceModelFilter.options = models.map((name) => ({value: name, name: name}));
            },
            () => {
                deviceModelFilter.options = [];
            }
        );
    }

    function loadDevices($scope, identifierId, deviceLoad) {
        unsubscribeFromDeviceStates();
        const sort = $scope.vm.query.isFrontEndSort() ? $scope.vm.defaultSortOrder : $scope.vm.query.order;
        var sortDirection = types.entityTable.sortOrder.asc.value;
        var sortField = sort;
        if (sortField[0] === '-') {
            sortDirection = types.entityTable.sortOrder.desc.value;
            sortField = sortField.substring(1);
        }
        var deviceModel = getColumnFilterSelected($scope, 'deviceModel');
        var active = getColumnFilterSelected($scope, 'active');
        return deviceLoad(identifierId, $scope.vm.query.limit, ($scope.vm.query.page - 1), sortField, sortDirection,
            $scope.vm.query.search, deviceModel, active)
    }

    function getColumnFilterSelected($scope, key) {
        var filters = ($scope.vm && $scope.vm.columnFilters) || [];
        var match = filters.filter((f) => f.key === key)[0];
        return match ? match.selected : undefined;
    }

    function unsubscribeFromDeviceStates() {
        for (var id in deviceStateSubscriptions) {
            deviceStateSubscriptions[id]();
        }
        deviceStateSubscriptions = {};
    }

    function subscribeForDevicesState($scope, devices) {
        devices.forEach(
            (device) => {
                if (angular.isUndefined(deviceStateSubscriptions[device.id.id])){
                    deviceStateSubscriptions[device.id.id] = deviceService.subscribeForDeviceStateData(device.id.id,
                        (deviceState) => {
                            var result = $filter('filter')(devices, {id: {id: device.id.id} }, true);
                            if (result && result.length) {
                                var entity = result[0];
                                $scope.$apply(() => {
                                    entity.active = deviceState.active;
                                    entity.lastActivityTime = deviceState.lastActivityTime;
                                });
                            }
                        }
                    );
                }
            }
        );
    }

    function moveDeviceToApplication($event, device, tableConfiguration) {
        var onEntitySelected = (targetApplicationId) => {
            device.applicationId = targetApplicationId;
            return deviceService.saveDevice(device);
        };
        tkDialogs.selectEntity($event, types.entityType.application,
            'device.move-to-application', 'action.move',
            'device.select-target-move-application-text',
            'application.application-not-found-text',
            'application.target-application-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function addDeviceToMulticastGroup($event, device, tableConfiguration) {
        var onEntitySelected = (targetMulticastGroupId) => {
            return multicastGroupService.addDevicesToMulticastGroup(targetMulticastGroupId.id, { devicesUuids: [ device.id.id ] });
        };
        tkDialogs.selectEntity($event, types.entityType.multicast_group,
            'device.add-to-multicast-group', 'action.ok',
            'device.select-target-add-to-multicast-group-text',
            'multicast-group.no-multicast-group-text',
            'multicast-group.target-multicast-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function removeDeviceFromMulticastGroup($event, multicastGroupId, device, tableConfiguration) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('device.remove-device-from-multicast-title', { name: device.name }))
            .htmlContent($translate.instant('device.remove-device-from-multicast-text'))
            .ariaLabel($translate.instant('entity-table.remove-entity'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
            $rootScope.shouldOverlay = true;
            multicastGroupService.deleteDeviceFromMulticastGroup(multicastGroupId, device.id.id).then(
                () => {
                    $rootScope.shouldOverlay = false;
                    tableConfiguration.reloadEntities(true);
                }, () => {
                    $rootScope.shouldOverlay = false;
                }
            )
        }, function () { });
    }

    function openApplicationDetails($event, applicationId) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.applications', {entityId: applicationId});
    }

    function moveDevicesToApplication($event, devices, tableConfiguration) {
        var onEntitySelected = (targetApplicationId) => {
            var tasks = [];
            devices.forEach((device) => {
                device.applicationId = targetApplicationId;
                tasks.push(deviceService.saveDevice(device));
            });
            return $q.all(tasks);
        };
        tkDialogs.selectEntity($event, types.entityType.application,
            'device.move-to-application', 'action.move',
            'device.select-target-move-application-devices-text',
            'application.application-not-found-text',
            'application.target-application-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function addDevicesToMulticastGroup($event, devices, tableConfiguration) {
        var onEntitySelected = (targetMulticastGroupId) => {
            var devicesIds = devices.map(device => device.id.id);
            return multicastGroupService.addDevicesToMulticastGroup(targetMulticastGroupId.id, { devicesUuids: devicesIds });
        };
        tkDialogs.selectEntity($event, types.entityType.multicast_group,
            'device.add-to-multicast-group', 'action.ok',
            'device.select-target-add-devices-to-multicast-group-text',
            'multicast-group.no-multicast-group-text',
            'multicast-group.target-multicast-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function removeDevicesFromMulticastGroup($event, multicastGroupId, devices, tableConfiguration) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('device.remove-devices-from-multicast-title', {count: devices.length}, 'messageformat'))
            .htmlContent($translate.instant('device.remove-devices-from-multicast-text'))
            .ariaLabel($translate.instant('entity-table.remove-entities'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
            var tasks = [];
            $rootScope.shouldOverlay = true;
            devices.forEach((device) => {
                tasks.push(multicastGroupService.deleteDeviceFromMulticastGroup(multicastGroupId, device.id.id));
            });
            $q.all(tasks).then(
                () => { 
                    $rootScope.shouldOverlay = false;
                    tableConfiguration.reloadEntities(true);
                }, () => {
                    $rootScope.shouldOverlay = false;
                }
            )
        }, function () { });
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('device.devices');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function loadDevice(deviceId) {
        var deferred = $q.defer();
        deviceService.getDevice(deviceId).then(
            (device) => {
              device &&
                deviceService.getDeviceFCnts(deviceId).then(
                    (fCnts) => {
                      if (fCnts) {
                        device.originFCnts = angular.copy(fCnts);
                        device.fCnts = fCnts;
                        networkSettingsService.getNetworkSettings(types.entityType.device, deviceId).then(
                            (networkSettings) => {
                                device.originNetworkSetting = angular.copy(networkSettings);
                                device.networkSettings = networkSettings;
                                deviceService.getSession(deviceId).then(
                                    (sessionNetworkSettings) => {
                                        device.originSessionNetworkSetting = angular.copy(sessionNetworkSettings);
                                        device.sessionNetworkSettings = sessionNetworkSettings;
                                    }, () => {
                                        $log.error('Failed to get device session');
                                    }
                                )
                                apiLimitsService.getApiLimits(types.entityType.device, deviceId).then(
                                    (apiLimits) => {
                                        device.originApiLimits = angular.copy(apiLimits);
                                        device.apiLimits = apiLimits;
                                        deviceService.getDeviceMulticastGroups(deviceId).then(
                                            (multicastGroups) => {
                                                device.originMulticastGroups = angular.copy(multicastGroups);
                                                device.multicastGroups = multicastGroups;
                                                deferred.resolve(device);
                                            },
                                            () => {
                                                deferred.reject();
                                            }
                                        )
                                    },
                                    () => {
                                        deferred.reject();
                                    }
                                );
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                      }
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveDevice(device) {
        var deferred = $q.defer();
        var networkSettings = device.networkSettings;
        var sessionNetworkSettings = device.sessionNetworkSettings;
        var apiLimits = device.apiLimits;
        var fCnts = device.fCnts;
        var multicastGroups = device.multicastGroups;

        var originNetworkSettings = device.originNetworkSetting;
        var originSessionNetworkSettings = device.originSessionNetworkSetting;
        var originApiLimits = device.originApiLimits;
        var originFCnts = device.originFCnts;
        var originMulticastGroups = device.originMulticastGroups;

        function saveDeviceFCnts(device) {
            var deferred = $q.defer();
            deviceService.saveDeviceFCnts(device.id.id, fCnts).then(
                (fCnts) => {
                    device.fCnts = fCnts;
                    device.originFCnts = angular.copy(fCnts);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                });
            return deferred.promise;
        }

        function saveApiLimits(device) {
            var deferred = $q.defer();
            apiLimitsService.saveApiLimits(apiLimits).then(
                (apiLimits) => {
                    device.apiLimits = apiLimits;
                    device.originApiLimits = angular.copy(apiLimits);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function saveNetworkSettings(device) {
            var deferred = $q.defer();
            networkSettingsService.saveNetworkSettings(networkSettings).then(
                (networkSettings) => {
                    device.networkSettings = networkSettings;
                    device.originNetworkSetting = angular.copy(networkSettings);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        // Since the PATCH request updates device session values asynchronously, the changes might not be available immediately.
        // To ensure we fetch the updated device session data, we attempt to retrieve it up to 3 times, waiting 500ms between each attempt.
        function fetchUpdatedDeviceSession(device) {
            var deferred = $q.defer();
            let attempts = 0;
            const maxAttempts = 3;
            const interval = 500;

            function checkUpdate() {
                deviceService.getSession(device.id.id).then((newSessionNetworkSetting) => {
                    if (!angular.equals(device.originSessionNetworkSetting, newSessionNetworkSetting) || attempts >= maxAttempts) {
                        deferred.resolve(newSessionNetworkSetting);
                    } else {
                        attempts++;
                        $timeout(checkUpdate, interval);
                    }
                }, () => { deferred.reject() }
                );
            }

            checkUpdate();
            return deferred.promise;
        }

        function saveSessionNetworkSettings(device) {
            var deferred = $q.defer();
            deviceService.setSession(device.id.id, sessionNetworkSettings).then(
                () => {
                    fetchUpdatedDeviceSession(device).then(
                        (sessionNetworkSettings) => {
                            device.sessionNetworkSettings = sessionNetworkSettings;
                            device.originSessionNetworkSetting = angular.copy(sessionNetworkSettings);
                            deferred.resolve(device);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                }, () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function saveMulticastGroups(device) {
            var deferred = $q.defer();
            var tasks = [];
            multicastGroups.forEach((multicastGroup) => {
                if (originMulticastGroups.findIndex(mg => mg.id.id === multicastGroup.id.id) === -1) {
                    tasks.push(multicastGroupService.addDevicesToMulticastGroup(multicastGroup.id.id, { devicesUuids: [device.id.id] }));
                }
            })
            originMulticastGroups.forEach((multicastGroup) => {
                if (multicastGroups.findIndex(mg => mg.id.id === multicastGroup.id.id) === -1) {
                    tasks.push(multicastGroupService.deleteDeviceFromMulticastGroup(multicastGroup.id.id, device.id.id));
                }
            });
            return $q.all(tasks).then(
                () => {
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                }
            )
        }

        var tasks = [];
        tasks.push(deviceService.saveDevice(device));
        if (!angular.equals(originNetworkSettings, networkSettings)) {
            tasks.push(saveNetworkSettings(device));
        }
        if (!angular.equals(originSessionNetworkSettings, sessionNetworkSettings)) {
            tasks.push(saveSessionNetworkSettings(device));
        }
        if (!angular.equals(originApiLimits, apiLimits)) {
            tasks.push(saveApiLimits(device));
        }
        if (!angular.equals(originFCnts, fCnts) && deviceService.isAbpEnabled(device)) {
            tasks.push(saveDeviceFCnts(device));
        }
        if (!angular.equals(originMulticastGroups, multicastGroups)) {
            tasks.push(saveMulticastGroups(device));
        }

        $q.all(tasks).then(
            (results) => {
                deferred.resolve(results[results.length - 1]);
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/device/device-table.config.js